import { DROP } from '../common';
import { COLORS } from 'utils/colors';
import { isProd, futuraContractAddress } from 'utils/config';

const genesisConfig = {
  theme: {
    primary: COLORS.sand2,
    background: COLORS.black,
    copy: COLORS.white,
    highlight: COLORS.sand2,
    activeLink: COLORS.oranges.light,
  },
  maxSupply: 119,
};

const enigmaConfig = {
  theme: {
    primary: COLORS.pink,
    background: COLORS.black,
    copy: COLORS.white,
    highlight: COLORS.pink,
    activeLink: COLORS.oranges.light,
  },
  version: 'V2',
  maxSupply: 160,
};

const futuraConfig = {
  theme: {
    primary: COLORS.white,
    background: COLORS.black,
    copy: COLORS.white,
    highlight: COLORS.white,
    activeLink: COLORS.white,
  },
  maxSupply: 1,
};

export const DROP_CONFIG = {
  [DROP.genesis]: isProd()
    ? {
        ...genesisConfig,
        contractAddress: '0x8754F54074400CE745a7CEddC928FB1b7E985eD6',
        printingPressContractAddress: '0x8Cac485c30641ece09dBeB2b5245E24dE4830F27',
      }
    : {
        ...genesisConfig,
        contractAddress: '0x8Db71380503998a1C760143003f55B391E626668',
        printingPressContractAddress: '0x3363908CAEF78bF4aCFC7538a1b0dDFa730fAfAC',
      },
  [DROP.enigma]: isProd()
    ? {
        ...enigmaConfig,
        contractAddress: '0xa98771a46Dcb34B34cDAD5355718F8a97C8E603e',
      }
    : {
        ...enigmaConfig,
        contractAddress: '0x24E04e4979898e37aCDB2C0E7fF14a5658D5ac3b',
      },
    // TODO: use this instead of config direct
    [DROP.futura]: {
      ...futuraConfig,
      contractAddress: futuraContractAddress,
    }
};
